<template>
    <vs-row>
        <vs-col vs-w="12" class="p-2">
            <UserInfo :clientDetails="clientDetails" @studentUpdated="studentUpdated" />
        </vs-col>
        <!-- <vs-col vs-lg="3" vs-sm="12" class="p-2">
            <vs-card style="border: 1px solid #00CFDD;" class="content_mb_0 mb-0">
                <div class="flex flex-wrap justify-between items-center">
                    <p style="font-size: 18px;">Current Plan</p>
                    <p class="plan_badge">Basic</p>
                </div>
                <p class="text-muted">July 22, 2022</p>
                <p class="text-muted">1 User</p>
                <vs-button class="w-full mt-4">Upgrade Plan</vs-button>
            </vs-card>
        </vs-col> -->
        <vs-col vs-lg="6" vs-sm="12" class="p-2">
            <div>
               <Timeline :student_id="$route.params.client_id"
          :new_activity="new_activity" />
            </div>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="p-2">
            <vs-card class="content_mb_0 mb-0">
                <div slot="header" class="flex flex-wrap justify-between items-center">
                    <h4>Permissions</h4>
                    <vs-tooltip text="View All" color="primary">
                      <vs-button type="border" color="primary" icon-pack="feather" icon="icon-eye" />
                    </vs-tooltip>
                </div>
                <div>
                    <h6 class="mb-2">Schedule</h6>
                    <div style="height: 175px; overflow-y: auto;" class="vertical_scrollbar">
                        <div class="user_schedule_holder" v-for="(eachScheduleData, index) in schedules" :key="index">
                            {{ eachScheduleData.title }}
                            <vs-checkbox v-model="eachScheduleData.active" />
                        </div>
                    </div>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
</template>

<script>
import UserInfo from '@/views/pages/v1/StudentProfile/components/account/user_info.vue'
import Timeline from '@/views/pages/v1/StudentProfile/components/account/timeline.vue'

export default {
  data () {
    return {
      schedules: [
        {
          id: 1,
          title: 'Student Course Schedule View',
          active: true
        },
        {
          id: 2,
          title: 'Teacher Course Schedule View',
          active: true
        },
        {
          id: 3,
          title: 'Room view',
          active: true
        },
        {
          id: 4,
          title: 'Cancel Schedule',
          active: true
        },
        {
          id: 5,
          title: 'Reschedule Session',
          active: true
        }
      ]
    }
  },

  props: {
    clientDetails:{
      default:null
    },
    new_activity:{
      default:null
    }
  },
  components: {
    UserInfo,
    Timeline
  },
  methods: {
    studentUpdated (obj) {
      this.new_activity = obj
    }
  }
}
</script>